<template>
  <div class="item"
    :class="{open: isFold, off: !item.visible, active: item.checked}">
    <div class="box">
      <!-- channel logo -->
      <div class="inner">
        <!-- logo -->
        <div class="logo">
          <label class="uploadChLogo"
            :for="`uploadChLogo_${item.id}`">
            <input type="file"
              :id="`uploadChLogo_${item.id}`"
              @change="uploadLogo($event)">
            <img src="@/assets/img/ico_upload_image.svg" alt="" />
          </label>
          <img :src="item.logo" alt="" />
        </div>
        <!-- //logo -->
        <!-- info state -->
        <div v-if="item" class="chState">
          <div class="stateItem toCapitalize" data-state="name" :class="{disabled: !hasName}">{{locale.name}}</div>
          <div class="stateItem toCapitalize" data-state="no" :class="{disabled: !hasNo}">{{locale.no}}</div>
          <div class="stateItem toCapitalize" data-state="genre" :class="{disabled: !hasGenre}">{{locale.genre}}</div>
          <div class="stateItem toCapitalize" data-state="lang" :class="{disabled: !hasLang}">{{locale.lang}}</div>
        </div>
        <!-- //info state -->
        <button type="button" class="btnFold" @click="isFold = !isFold"><span class="blind">fold</span></button>
      </div>
      <!-- //channel logo -->
      <!-- check channel -->
      <div class="checkbox chkService">
        <input type="checkbox"
          v-model="item.checked"
          :id="`ch_${item.id}`"
          :value="item.id" />
        <label :for="`ch_${item.id}`">
          <span class="blind">{{item.name}}</span>
        </label>
      </div>
      <!-- //check channel -->
      <!-- delete channel -->
      <button type="button" class="btnDel"
        @click="delCh">
        <img src="@/assets/img/ico_close_black.svg" alt="delete item" />
      </button>
      <!-- //delete channel -->
      <!-- channel info -->
      <div class="option">
        <div class="optionItem">
          <label class="optionLabel toCapitalize">{{locale.name}}</label>
          <input type="text" class="optionValue input" v-model="item.name">
        </div>
        <div class="optionItem setNo">
          <label class="optionLabel toCapitalize">
            {{locale.no}}
            <button type="button" class="btn sizeXs btnGrey"
              :class="{active: activeCmd, btnPrimary: hasCmd}"
              @click="setCmd">
              CMD
            </button>
          </label>
          <input type="text" class="optionValue input" v-model="item.no">
          <div v-if="activeCmd" class="setCmd mt5">
            <input type="text" class="optionValue input" v-model="item.cmd">
            <button type="button" class="btnDel" @click="delCmd"><img src="@/assets/img/ico_close_black.svg" alt="delete item" /></button>
          </div>
        </div>
        <div class="optionItem">
          <label class="optionLabel toCapitalize">{{locale.genre}}</label>
          <select class="optionValue input toCapitalize" v-model="item.genre">
            <option v-for="g in genre" :key="g" :value="g">{{getGenreName(g)}}</option>
          </select>
        </div>
        <div class="optionItem">
          <label class="optionLabel toCapitalize">{{locale.language}}</label>
          <select class="optionValue input" v-model="item.lang">
            <option v-for="l in lang" :key="l" :value="l">{{langName(l)}}</option>
          </select>
        </div>
        <div class="optionBtns">
          <button type="button" class="btn btnFull toCapitalize"  @click="saveCh()">{{locale.save}}</button>
        </div>
      </div>
      <!-- //channel info -->
    </div>
  </div>
</template>

<script>
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'

export default {
  props: [
    'locale',
    'item',
    'genre',
    'lang',
    'chkAll'
  ],
  computed: {
    hasName () {
      return !!this.item.name && this.item.name.trim() !== ''
    },
    hasCmd () {
      return !!this.item.cmd && this.item.cmd.trim() !== ''
    },
    hasNo () {
      return !!this.item.no && this.item.no.trim() !== ''
    },
    hasGenre () {
      return !!this.item.genre && this.item.genre !== ''
    },
    hasLang () {
      return !!this.item.lang && this.item.lang !== ''
    }
  },
  mounted () {
    this.activeCmd = this.item.cmd && this.item.cmd.trim() !== ''
  },
  data () {
    return {
      isFold: false,
      activeCmd: false
    }
  },
  methods: {
    setCmd () {
      const locale = this.locale
      if (this.hasCmd) {
        this.activeCmd = !this.activeCmd
      } else {
        if (!this.activeCmd && window.confirm(`${locale.message_add_tv_cmd_1}\n${locale.message_add_tv_cmd_2}`)) {
          this.activeCmd = true
        } else {
          this.activeCmd = false
        }
      }
    },
    delCmd () {
      if (window.confirm(this.locale.confirm_delete_tv_cmd)) {
        delete this.item.cmd
        this.activeCmd = false
      }
    },
    langName (c) {
      const code = `lang_${c}`
      return this.locale[code]
    },
    getGenreName (id) {
      const genre = `genre_${id}`
      return this.locale[genre]
    },
    uploadLogo (e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const chId = this.item.id
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          this.$store.commit('tv/updateChLogo', { id: chId, logo: res.source })
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    validateOnSave () {
      const data = this.item
      const locale = this.locale
      if (data.logo === '') {
        alert(locale.validate_ch_logo)
      } else if (data.name.trim() === '') {
        alert(locale.validate_ch_name)
      } else if (data.no.trim() === '') {
        alert(locale.validate_ch_number)
      } else if (data.genre === '') {
        alert(locale.validate_ch_genre)
      } else if (data.lang === '') {
        alert(locale.validate_ch_lang)
      } else {
        return true
      }
    },
    saveCh () {
      if (this.validateOnSave()) {
        if (window.confirm(this.locale.confirm_save_tv_channel)) {
          this.$store.commit('onLoading', true)
          this.$store.dispatch('tv/setChannel').then(() => {
            this.$store.dispatch('tv/getChData')
            this.$store.commit('tv/initCh')
            alert(this.locale.complete_save)
            this.$store.commit('onLoading', false)
          })
        }
      }
    },
    delCh () {
      if (window.confirm(this.locale.confirm_delete_tv_channel)) {
        const id = this.item.id
        this.$store.commit('onLoading', true)
        this.$store.dispatch('tv/delCh', id).then(() => {
          this.$store.dispatch('tv/setChannel').then(() => {
            this.$store.dispatch('tv/getChData')
            alert(this.locale.complete_delete)
            this.$store.commit('onLoading', false)
          })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.uploadChLogo {
  display: none;
  position: absolute;
  top: 15px;
  left: 50%;
  width: 40px;
  height: 40px;
  padding: 5px;
  border: 1px solid $color-lgrey2;
  border-radius: 100%;
  background-color: $bg-default;
  transform: translate(-50%, 0);
  opacity: 0.8;
  cursor: pointer;
  img {
    position: relative;
    top: 2px;
    left: 2px;
    width: 30px;
  }
}
.inner:hover .uploadChLogo {
  display: block;
}
.setNo label {
  position: relative;
  .btn {
    position: absolute;
    top: 50%;
    right: 0;
    padding: 0 0.5em;
    font-size: 12px;
    border-radius: 2px;
    transform: translate(0, -50%);
    opacity: 0.5;
    &.active {
      opacity: 1;
    }
  }
}
.setCmd {
  position: relative;
  .btnDel {
    top: 0;
    width: 28px;
    height: 100%;
    padding: 10px;
  }
}
</style>
